import { render, staticRenderFns } from "./BodyPresetGridThumbnailHover.vue?vue&type=template&id=004c180d&scoped=true"
import script from "./BodyPresetGridThumbnailHover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BodyPresetGridThumbnailHover.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BodyPresetGridThumbnailHover.vue?vue&type=style&index=0&id=004c180d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c180d",
  null
  
)

export default component.exports